<template>
    <div :class="phoneClass || 'home-container-wrapper'">
        <div class="home-container">
            <div class="top-tip" v-if="phoneClass">
                <p>{{$t('sideBar.home')}}</p>
                <my-tabs @changeTabActive="changeTabActive"></my-tabs>
            </div>
            <el-row :gutter="20">
                <el-col :span="6" v-if="!phoneClass || (phoneClass && tabActive === 3)">
                    <div class="home-left">
                        <!-- 设备统计 -->
                        <div class="device-stat item">
                            <div class="block-header">
                                <h2>{{$t('homePage.device_statistics')}}</h2>
                            </div>
                            <my-echarts key="stat" type="stat-chart" @getConsume="getConsume"></my-echarts>
                        </div>
                        <!-- 设备可用率 -->
                        <div class="device-rate item">
                            <div class="block-header">
                                <h2>{{$t('homePage.device_availability')}}</h2>
                            </div>
                            <my-echarts key="rate" type="rate-chart" @getConsume="getConsume"></my-echarts>
                        </div>
                        <div class="material-stat item">
                            <div class="block-header">
                                <h2>{{$t('homePage.consumables_statistics')}}</h2>
                            </div>
                            <div class="material-content">
                                <div class="content-block">
                                    <div class="block-floor">
                                        <img src="../../assets/img/icon/home-lube.png"  class="icon">
                                        <div class="img-right">
                                            <p style="width: 90px">{{$t('homePage.lubricator_total')}}<br> &nbsp;</p>
                                            <h2>{{consume.total_count}}</h2>
                                        </div>
                                    </div>
                                    <div class="block-floor">
                                        <img src="../../assets/img/icon/home-use.png"  class="icon">
                                        <div class="img-right">
                                            <p style="width: 90px">{{$t('homePage.monthly_consumption')}}</p>
                                            <h2>{{consume.consumed_this_month}}</h2>
                                        </div>
                                    </div>
                                </div>
                                <div class="content-block">
                                    <div class="block-floor">
                                        <img src="../../assets/img/icon/home-supply.png"  class="icon">
                                        <div class="img-right">
                                            <p style="font-size: 12px;width: 96px">{{$t('homePage.tank')}}</p>
                                            <h2>{{consume.need_add_count}} </h2>
                                        </div>
                                    </div>
                                    <div class="block-floor">
                                        <img src="../../assets/img/icon/home-use.png"  class="icon">
                                        <div class="img-right">
                                            <p style="width: 90px">{{$t('homePage.year_consumption')}}</p>
                                            <h2>{{consume.consumed_this_year}}</h2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="!phoneClass">
                                <div class="page" style="margin-bottom: 10px;margin-top: 18px" @click="toNewPage('https://www.skf.com/cn/zh/products/lubrication-solutions/index.html')" ><span>{{$t('homePage.SKF_lubrication_solution')}}</span></div>
                                <div class="page" style="margin-bottom: 10px" @click="toNewPage('https://www.skf.com/cn/zh/industry-solutions/index.html')"><span>{{$t('homePage.SKF_industry_solutions')}}</span></div>
                                <div class="page" style="margin-bottom: 10px" @click="toNewPage('https://www.skf.com/cn/zh/knowledge-centre/engineering-tools/skfdialset.html')">
                                    <span>SKF DialSet</span>
                                    <!--<el-button>SKF DialSet</el-button>-->
                                </div>
                                <div class="page">
                                    <span >{{$t('devicePage.contact_us')}}：lcp@skf.com</span>
                                    <!--<el-button>联系我们:</el-button>-->
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </el-col>
                <el-col :span="18" v-if="!phoneClass || (phoneClass && tabActive === 1)">
                    <div class="home-right">
                        <div class="device-list-wrapper">
                            <div class="list-header" v-if="!phoneClass">
                                <h2>{{$t('devicePage.device_list')}}</h2>
                                <my-tabs class="tab" @changeTabActive="changeTabActive"></my-tabs>
                            </div>
                            <div class="list-content">
                                <device-table pageType='home' v-if="tabActive === 1"></device-table>
                                <device-map class="map" v-else-if="tabActive === 2 && !phoneClass"></device-map>
                            </div>
                        </div>
                    </div>
                </el-col>
                <el-col :span="18" v-if="phoneClass && tabActive === 2" class="phone-map">
                    <device-map class="map"></device-map>
                </el-col>
            </el-row>
        </div>
        <div class="home-footer" v-if="!phoneClass">Copyright © 2019-{{ nowYear }} SKF China</div>
    </div>
</template>


<script>
import Core from "core/core";
import deviceTable from '../../components/device-table'
import deviceMap from '../../components/device-map/device-map.vue'
import echarts from "echarts";
// import G2 from '@antv/g2';
import { Chart } from '@antv/g2';
// import DataSet from '@antv/data-set';
import {refresh} from "core/winSize"
import MyTabs from "./components/MyTabs.vue"
import MyEcharts from './components/MyEcharts.vue';
export default {
    data() {
        return {
            lang: '',
            zh: true,
            phoneClass: '',
            consume: {
                count: '',                  // 设备总数
                consumed_this_month: '',    // 月消耗量
                consumed_this_year: '',     // 年消耗量
                need_add_count: '',         // 补充量
                total_count: '',            // 总润滑剂
                availability: '',           // 可用率
	            shutdown_count: '',            // 离线数
                alarm_count: '',            // 告警数
                exception_count: '',        // 异常数
                normal_count: ''            // 正常数
            },
            tabActive: 1,
            nowYear: new Date().getFullYear(),
        };
    },
    components: {
        deviceTable,
        deviceMap,
        MyTabs,
        MyEcharts,
    },

	created() {
		refresh(this,'phoneClass-phoneHeader');
		window.onresize = function(){
			setTimeout(function(){
				refresh(this,'phoneClass-phoneHeader');
			},10)
		};
	},
    mounted() {},
    computed: {
    },
    methods: {
        test() {
            // console.log(this.$refs['g2-guide-html']);
            let guide = document.getElementsByClassName('g2-guide-html')[0];
            // console.log(guide.querySelector('.title'))
        },
        toNewPage(page) {
            window.open(page)
            // console.log(page);
        },
        changeTabActive(e) {
            this.tabActive = e
            console.log('this.tabActive: ', this.tabActive);
        },
        getConsume(e) {
            this.consume = e
        }
    },


};
</script>

<style lang="scss">
.home-container-wrapper {
    width: 99%;
    .home-container {
        h2 {
            font-size: 16px;
            color: #363d42;
            padding-left: 20px;
        }
        >.el-row {
            margin-top: 50px;
            display: flex;
            justify-content: center;
            >.el-col-6 {
                width: 280px;
                .home-left {
                    >div {
                        border: 1px solid #dce0ea;
                        border-radius: 4px;
                    }
                    .block-header {
                        height: 35px;
                        line-height: 35px;
                        border-bottom: 1px solid #efefef;
                    }
                    .device-stat {
                        min-height: 170px;
                        background: white;
                    }
                    .device-rate {
                        background: white;
                        height: 170px;
                        margin: 10px 0;
                        .rate-chart {
                            height: 135px;
                        }
                    }
                    .material-stat {
                        background: white;
                        .material-content {
                            margin-top: 6px;
                            .content-block {
                                display: inline-block;
                                width: 50%;
                                padding: 5px 5px;
                                .block-floor {
                                    img {
                                        position: absolute;
                                    }
                                    margin-bottom: 5px;
                                    .icon {
                                        width: 20px;
                                        height: 20px;
                                        vertical-align: top;
                                    }
                                    .img-right {
                                        display: inline-block;
                                        vertical-align: top;
                                        margin-left: 25px;
                                        p {
                                            font-size: 14px;
                                            color: #8E9AAD;
                                            line-height: 22px;
                                            margin-bottom: 2px;
                                        }
                                        h2 {
                                            font-size: 18px;
                                            color: #363D42;
                                        }
                                    }
                                    &:last-child {
                                        margin-bottom: 0;
                                    }
                                }
                            }
                        }
                        .page {
                            background: #0f58d6;
                            color: white;
                            font-weight: 400;
                            font-size: 14px;
                            text-align: center;
                            margin-left: 30px;
                            margin-right: 30px;
                            margin-bottom: 26px;
                            cursor: pointer;
                            border-radius: 3px;
                            height: 28px;
                            line-height: 28px;
                        }
                    }
                }
            }
            >.el-col-18 {
                background: white;
                width: calc(95% - 280px);
                .home-right {
                    width: 100%;
                    height: 100%;
                    .device-list-wrapper {
                        height: 100%;
                        .list-header {
                            height: 35px;
                            line-height: 35px;
                            border-bottom: 1px solid #efefef;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            .tab {
                                margin-right: 20px;
                            }
                        }
                        .list-content {
                            width: 100%;
                            height: calc(100% - 35px);
                            .map {
                                width: 100%;
                                height: 100%;
                            }
                        }
                    }
                }
            }
        }
    }
}

.phoneClass-phoneHeader {
    .home-container {
        padding-bottom: 50px;
        background-color: #E5EBEF;
        .top-tip {
            background-color: #fff;
            padding: 10px 16px;
            display: flex;
            justify-content: space-between;
            p {
                font-size: 20px;
                font-weight: 600;
                color: #353C41;
                line-height: 28px;
            }
        }
        .el-row{
            margin: 0 !important;
            padding: 0 !important;
            .el-col {
                margin: 0 !important;
                padding: 0 !important;
                width: 100%;
                .block-header {
                    padding-left: 30px;
                    font-size: 16px;
                    color: #363D42;
                }
            }
            .el-col-6 {
                .home-left {
                    padding: 0 16px;
                    .item {
                        background-color: #fff;
                        margin-bottom: 10px;
                        .block-header {
                            padding:14px 0px 14px 16px;
                            font-size: 15px;
                            font-weight: 500;
                            color: #2D2E32;
                            line-height: 21px;
                            border-bottom: 1px solid #EDEFF4;
                        }
                    }
                    .device-stat {
                            // min-height: 170px;
                        .stat-chart {
                            canvas {
                                width: 100%;
                                /*height: 200px !important;*/
                            }
                        }
                    }
                    .device-rate {
                        width: 100%;
                        .rate-chart {
                            height: 160px ;
                        }
                    }
                    .material-stat {
                        .material-content {
                            text-align: center;
                            .content-block {
                                display: inline-block;
                                vertical-align: top;
                                margin-bottom: 15px;
                                text-align: left;
                                margin-top: 10px;
                                margin-right: 20px;
                                .block-floor {
                                    margin-bottom: 15px;
                                    >* {
                                        display: inline-block;
                                    }
                                    img {
                                        vertical-align: top;
                                        height: 20px;
                                        margin-right: 5px;
                                    }
                                    p {
                                        color: #8E9AAD;
                                    }
                                }
                            }
                        }
                        /*.page {*/
                            /*background: #0f58d6;*/
                            /*color: white;*/
                            /*font-weight: 800;*/
                            /*font-size: 20px;*/
                            /*text-align: center;*/
                            /*margin-left: 30px;*/
                            /*margin-right: 30px;*/
                            /*margin-bottom: 26px;*/
                            /*cursor: pointer;*/
                            /*border-radius: 3px;*/
                            /*height: 28px;*/
                            /*line-height: 28px;*/
                        /*}*/
                    }
                }
            }
            .el-col-18 {
                .list-header {
                    padding-left: 10px;
                    // .tabs {
                    //     display: none;
                    // }
                }
                .phoneClass-device-table {
                    .search-bar {
                        padding-left: 10px;
                    }
                    .superBtn {
                        .status-index {
                            .el-select {
                                width: 70%;
                            }
                        }
                    }
                }
            }
        }
        .pagination {
            padding: 0 !important;
            margin: 10px 0 30px;
            .el-pager {
                .number {
                    min-width: 25px;
                    margin: 0 3px;
                }
            }
            .btn-prev,.btn-next{
                min-width: 20px;
            }
        }
        .phone-map {
            width: 100%;
            height: calc(100vh - 168px);
            .map{
                width: 100%;
                height: 100%;
            }
        }
    }
    

}
.home-footer {
    width: 100%;
    text-align: center;
    /*position: absolute;*/
    margin-top: 50px;
    margin-bottom: 30px;
}
</style>
